import { Controller } from "@hotwired/stimulus"
import { useTransition } from 'stimulus-use'

export default class extends Controller {
  static targets = ['background', 'sidebar']

  connect () {
    if (!this.backgroundTarget.classList.contains('hidden')) {
      this.backgroundTarget.classList.toggle('hidden')
    }

    useTransition(this, {
      element: this.sidebarTarget
    })
  }

  toggle(event) {
    this.toggleTransition()
    this.backgroundTarget.classList.toggle('hidden')

    event.stopPropagation();
  }

  close (event) {
    this.leave()
    this.backgroundTarget.classList.toggle('hidden')

    event.stopPropagation();
  }

  hide (event) {
    if (!this.sidebarTarget.contains(event.target) && !this.sidebarTarget.classList.contains('hidden')) {
      this.leave()
      this.backgroundTarget.classList.toggle('hidden')
    }
  }
}
